import React, { useContext, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { UserContext } from '../../../context/userContext';
import DeleteModal from '../DeleteModal/DeleteModal';
import ErrorModal from '../../Common/ErrorModal/ErrorModal';
import css from './DeleteButton.module.css';

interface DeleteButtonProps {
  selectedFiles: Set<string>;
  onDeleteComplete: () => void;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ 
  selectedFiles,
  onDeleteComplete
}) => {
  const { user } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleDelete = async () => {
    if (selectedFiles.size === 0) return;
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      console.log('Starting file deletion...');
      console.log('Original selected files:', Array.from(selectedFiles));

      // Process each file path for API
      const apiFilePaths = Array.from(selectedFiles).map(path => {
        console.log('\nProcessing path for deletion:', path);
        
        const pathWithPreservedSlashes = path.replace(/%2F/g, 'REPLACINGSLASHES');
        console.log('Path after preserving slashes:', pathWithPreservedSlashes);
        
        const decodedPath = decodeURIComponent(pathWithPreservedSlashes);
        console.log('Path after decoding:', decodedPath);
        
        const finalPath = decodedPath.replace(/REPLACINGSLASHES/g, '%2F');
        console.log('Final API path:', finalPath);
        
        return finalPath;
      });

      console.log('\nFinal paths to delete:', apiFilePaths);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Documents`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user?.accessToken}`,
          },
          body: JSON.stringify(apiFilePaths),
        }
      );

      console.log('Delete response status:', response.status);
      console.log('Delete response status text:', response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Delete error response:', errorText);
        throw new Error(`Failed to delete files: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      console.log('Delete successful. Result:', result);
      onDeleteComplete();
    } catch (error) {
      console.error('Detailed delete error:', error);
      setErrorMessage(error instanceof Error ? error.message : 'Failed to delete files. Please try again.');
      setShowErrorModal(true);
    } finally {
      setShowModal(false);
    }
  };

  const handleCancelDelete = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <DeleteModal
          fileCount={selectedFiles.size}
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
      {showErrorModal && (
        <ErrorModal
          title="Delete Error"
          message={errorMessage}
          onClose={() => setShowErrorModal(false)}
        />
      )}
      <button
        className={css.deleteButton}
        onClick={handleDelete}
        disabled={selectedFiles.size === 0}
      >
        <FaTrash className={css.deleteIcon} />
        Delete Selected ({selectedFiles.size})
      </button>
    </>
  );
};

export default DeleteButton; 